import React from 'react';
import { VIDEO_ORIENTATIONS } from '../helpers/video';
import { breakpointQueries } from '../styleguide';
import { useMediaQuery } from './useMediaQuery';

type VideoUrlProps = {
  largeScreen: {
    videoUrl?: string;
    posterUrl?: string;
  };
  smallScreen?: {
    videoUrl?: string;
    posterUrl?: string;
  };
};

export const useDeviceVideoUrls = ({ largeScreen, smallScreen }: VideoUrlProps) => {
  const [isTabletOrLarger, mediaQueryDetermined] = useMediaQuery(breakpointQueries.tablet);
  const [videoUrl, setVideoUrl] = React.useState(largeScreen.videoUrl || '');
  const [posterUrl, setPosterUrl] = React.useState(largeScreen.posterUrl);

  React.useEffect(() => {
    if (mediaQueryDetermined && isTabletOrLarger === false && smallScreen) {
      smallScreen.videoUrl && setVideoUrl(smallScreen.videoUrl);
      smallScreen.posterUrl && setPosterUrl(smallScreen.posterUrl);
    }
  }, [isTabletOrLarger, mediaQueryDetermined, smallScreen]);

  return { videoUrl, posterUrl };
};

type VideoProps<T> = {
  landscapeVideo?: T;
  portraitVideo?: T;
};

export function useDeviceVideo<T>({ landscapeVideo, portraitVideo }: VideoProps<T>): T | undefined {
  const [isTabletOrLarger, mediaQueryDetermined] = useMediaQuery(breakpointQueries.tablet);
  const [video, setVideo] = React.useState(portraitVideo || landscapeVideo);

  React.useEffect(() => {
    if (mediaQueryDetermined && isTabletOrLarger && landscapeVideo) {
      setVideo(landscapeVideo);
    }
    if (mediaQueryDetermined && !isTabletOrLarger && portraitVideo) {
      setVideo(portraitVideo);
    }
  }, [isTabletOrLarger, mediaQueryDetermined, portraitVideo, landscapeVideo]);

  return video;
}

export function usePreferredVideoOrientation() {
  const [isTabletOrLarger, mediaQueryDetermined] = useMediaQuery(breakpointQueries.tablet);
  const [orientation, setOrientation] = React.useState(VIDEO_ORIENTATIONS.PORTRAIT);

  React.useEffect(() => {
    if (mediaQueryDetermined && isTabletOrLarger) {
      setOrientation(VIDEO_ORIENTATIONS.LANDSCAPE);
    }
    if (mediaQueryDetermined && !isTabletOrLarger) {
      setOrientation(VIDEO_ORIENTATIONS.PORTRAIT);
    }
  }, [isTabletOrLarger, mediaQueryDetermined]);

  return orientation;
}
